import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CompteSCGP, CompteSCGPCodeDivisionEnum } from 'src/app/api/model/compte-scgp.model';

@Component({
  selector: 'app-validation-compte-vmd',
  templateUrl: './validation-compte-vmd.component.html',
  standalone: false,
})
export class ValidationCompteVmdComponent implements OnInit {
  @Input() comptes: Array<CompteSCGP>;
  @Output() comptesSelectionnes = new EventEmitter<Array<CompteSCGP>>();

  selection: Array<CompteSCGP> = [];
  comptesTries: Array<CompteSCGP> = [];

  ngOnInit(): void {
    this.comptesTries = this.getComptesTries();
  }

  getComptesTries(): Array<CompteSCGP> {
    return (this.comptes ?? [])
      .filter((c) => c.codeDivision !== CompteSCGPCodeDivisionEnum.GPD)
      .slice()
      .sort(
        (a, b) =>
          (a.codeDivision ?? '')
            .trim()
            .toLowerCase()
            .localeCompare((b.codeDivision ?? '').trim().toLowerCase()) ||
          (a.descriptionCompte ?? '')
            .trim()
            .toLowerCase()
            .localeCompare((b.descriptionCompte ?? '').trim().toLowerCase()) ||
          (a.numeroCompte ?? '')
            .trim()
            .toLowerCase()
            .localeCompare((b.numeroCompte ?? '').trim().toLowerCase())
      );
  }

  onSelectionChange(event: CustomEvent) {
    const selection = event.detail?.value;
    this.selection = selection;
    this.comptesSelectionnes.emit(this.selection);
  }
}
